<template>
  <div v-if="showAdvertisement" class="adv_home">
    <img style="height: 70vh" src="~@/assets/advertisement_big.png" alt="" />
    <CloseCircleOutlined class="close_icon" @click="closeAll()"></CloseCircleOutlined>
  </div>
</template>
<script>
// CloseCircleFilled
import { CloseCircleOutlined } from "@ant-design/icons-vue"

export default {
  components: { CloseCircleOutlined },
  data() {
    return {
      showAdvertisement: true,
    }
  },
  computed: {},
  mounted() {
    this.init()
  },
  methods: {
    closeAll() {
      this.showAdvertisement = false
      localStorage.setItem("advertisementTime2", JSON.stringify(new Date().getTime()))
    },
    init() {
      let showTime = JSON.parse(localStorage.getItem("advertisementTime2"))
      showTime = showTime ? new Date(showTime) : ""
      if (
        !showTime ||
        new Date().getDate() != showTime.getDate() ||
        new Date().getMonth() != showTime.getMonth() ||
        new Date().getFullYear() != showTime.getFullYear()
      ) {
        this.showAdvertisement = true
        //   localStorage.setItem("advertisementTime", JSON.stringify(new Date().getTime()));
      } else {
        this.showAdvertisement = false
      }
    },
  },
}
</script>
<style lang="less" scoped>
.adv_home {
  position: fixed;
  bottom: auto;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  background: #00000087;
  align-items: center;
  justify-content: center;
  .close_icon {
    font-size: 43px;
    margin-top: 20px;
    color: #ebebeb;
  }
}
</style>
